module.exports = __webpack_public_path__ + "media/images/logos/samsung-cfe95aaa7033f94ebc23299114da0434.png";